export default {
  init() {
    // JavaScript to be fired on all pages

    // mobile navigation controls, target the hamburger menu icon
    const navMobileIcon = document.getElementsByClassName('nav-mobile-icon')[0];
    const nav = document.getElementsByTagName('nav')[0];

    navMobileIcon.addEventListener('click', function() {
      navMobileIcon.classList.toggle('is-open');
      nav.classList.toggle('is-open');
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js